import request from '@/axios'

// 获取-是否有打单分析入口
export function getOrderAnalysisPermission(data) {
  return request({
    url: '/inside/customerReview/getOrderAnalysis',
    data
  })
}
// 获取分析结果
export function getResult(data) {
  return request({
    url: '/inside/saleOrderProcess/getResult',
    data
  })
}
// 获取访客计划列表
export function getCommunicatePlanList(data) {
  return request({
    url: '/inside/saleOrderProcess/getCommunicatePlanList',
    data
  })
}
// 新增跟进记录
export function addCustomerCommunicate(data) {
  return request({
    url: '/inside/saleOrderProcess/addCustomerCommunicate',
    data
  })
}
